export enum UserRole {
  ADMIN = 'ADMIN',
}
